import React, { useMemo } from "react";

const RVTable = React.memo(({ reportData, totalcount, handlePrint, data }) => {
  const { storeName, mrvNo } = data?.document || {};

  const tableRows = useMemo(() => {
    if (!reportData.length) {
      return (
        <tr>
          <td colSpan="12" className="text-center">
            No data available.
          </td>
        </tr>
      );
    }

    return reportData.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{storeName}</td>
        <td>{mrvNo}</td>
        <td>
          <strong>{item.poNumber || "-"}</strong>
        </td>
        <td>{item.partNo}</td>
        <td>{item.description}</td>
        <td>{item.unitName}</td>
        <td>{item.qtyRequired}</td>
        <td>{item.approveQty}</td>
        <td>{item.qtyRecived}</td>
        <td>{item.status}</td>
        <td>{item.updatedAt?.split("T")[0]}</td>
      </tr>
    ));
  }, [reportData, storeName, mrvNo]);

  return (
    <div className="filter cm-content-box box-primary">
      <div className="content-title d-flex justify-content-between align-items-center">
        <div className="cpa">
          <i className="fa fa-list me-2"></i>Requisition Voucher Items
          <span className="badge bg-orange ms-2">{totalcount}</span>
        </div>
        <div className="d-flex align-items-center">
          {reportData.length > 0 && (
            <button className="btn btn-primary me-3" onClick={handlePrint}>
              Print
            </button>
          )}
        </div>
      </div>
      <div className="cm-content-body form excerpt">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Store</th>
                  <th>MRV No</th>
                  <th>PO No</th> {/* NEW */}
                  <th>Part No</th>
                  <th>Description</th>
                  <th>Unit</th>
                  <th>Required Qty</th>
                  <th>Approved Qty</th>
                  <th>Received Qty</th>
                  <th>Status</th>
                  <th>Updated Date</th>
                </tr>
              </thead>
              <tbody>{tableRows}</tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
});

export default RVTable;
